import { PropertyGroupStep } from "./types";

export const PropertyGroupChartLegendItems = [
  { color: "bg-content-200", label: "Segments" },
  { color: "bg-primary-500", label: "Property group" }
];

export const propertyGroupTitleMap = {
  [PropertyGroupStep.INITIAL_CONFIGURATION]: "initial configuration",
  [PropertyGroupStep.OWNER]: "owner",
  [PropertyGroupStep.STATE]: "state",
  [PropertyGroupStep.CITY]: "city",
  [PropertyGroupStep.ZIP]: "zip",
  [PropertyGroupStep.MARKET]: "market",
  [PropertyGroupStep.CONFIRM_GROUPS]: "confirm groups"
};
